export default {"src":"/_next/static/media/plus_circle.9e37810f.svg","height":18,"width":18,"blurWidth":0,"blurHeight":0};